import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setSnackbar } from 'redux/snackbar';
import Popover from '../components/popover/Popover';
import api from 'services/api';
import { useLocation } from 'react-router-dom';
import { filterMessageError } from './helpers';
import { formatDateTime } from 'utils';
import InputsService from 'services/InputsService';

export function useInputs() {
  const [inputs, setInputs] = useState([]);
  const [exportData, setExportData] = useState([]);
  const [openProgress, setOpenProgress] = useState(false);
  const [errors, setErrors] = useState([]);
  const [errorsWhenPosting, setErrorsWhenPosting] = useState([]);
  const selectedCycle = useSelector(
    (state) => state.selectedCycle.selectedCycle
  );
  const location = useLocation();
  const id = location?.state?.id;
  const pond = location?.state?.pond;
  const searchText = location?.state?.searchText ?? '';

  const dispatch = useDispatch();

  const columns = [
    {
      title: 'Viveiro',
      field: 'cycle.pond.description',
      hideFilterIcon: true,
      filtering: false,
      editable: 'never',
    },
    {
      title: 'Data de Inserção',
      field: 'put_at',
      type: 'datetime',
      filtering: false,
      hideFilterIcon: true,
      render: (rowData) => <p>{formatDateTime(rowData.put_at)}</p>,
    },
    {
      title: 'Insumos',
      field: 'supplies',
      editable: 'never',
      filtering: false,
      render: (rowData) => {
        let supplies = '';
        const suppliesvalue = '';
        rowData.supplies.forEach((supply) => {
          supplies += `${supply.supply?.name}: ${supply.quantity}, `;
        });
        return (
          <Popover
            data={supplies.slice(0, -2)}
            altdata={suppliesvalue.slice(0, -2)}
          />
        );
      },
      hideFilterIcon: true,
    },
  ];

  const columnsForExport = [
    {
      title: 'Ciclo',
      field: 'cycle',
    },
    {
      title: 'Viveiro',
      field: 'pond',
    },
    {
      title: 'Data de Inserção',
      field: 'put_at',
    },
    {
      title: 'Hora',
      field: 'put_hour_at',
    },
    {
      title: 'Insumos',
      field: 'supply',
    },
    {
      title: 'Quantidade',
      field: 'quantity',
    },
  ];

  useEffect(() => {
    async function loadData() {
      try {
        setOpenProgress(false);
        const response = await api.get(
          `/inputs/cycle-code/${selectedCycle.id}`,
          {
            params: id ? { cycle: id } : {},
          }
        );
        if (response.data) {
          const data = await response.data;
          setOpenProgress(true);
          setInputs(data);
        }
      } catch (err) {
        setErrors((prev) => [err.message, ...prev]);
      } finally {
        setOpenProgress(true);
      }
    }
    loadData();
  }, [id, selectedCycle]);

  useEffect(() => {
    async function loadInputsExport() {
      try {
        const response = await (
          await api.get(`/inputs/cycle-code/${selectedCycle.id}/export`)
        ).data;

        if (response.length === 0) {
          setOpenProgress(true);
        }
        if (response) {
          setExportData(response);
        }
      } catch (err) {
        setErrors((prev) => [err.message, ...prev]);
        setOpenProgress(true);
      }
    }
    loadInputsExport();
  }, [selectedCycle]);

  // eslint-disable-next-line consistent-return
  const handleImportDataPost = async (payload) => {
    if (!payload) throw new Error('Payload is required.');
    try {
      setOpenProgress(false);
      const result = await InputsService.importData(payload);
      const { errorsData, importedData, status, successMessage } = result;

      if (status === 201) {
        if (importedData.length === 0) {
          if (errorsData.length > 0) {
            return setErrorsWhenPosting(filterMessageError(errorsData));
          }
          return dispatch(
            setSnackbar(
              true,
              'error',
              'Erro ao importar planilha! Verifique se existe dados.'
            )
          );
        }
        if (importedData.length > 0) {
          const updatedList = await InputsService.inputsList(selectedCycle.id);
          setInputs(updatedList);
          dispatch(setSnackbar(true, 'success', successMessage));
          if (errorsData.length > 0) {
            setErrorsWhenPosting(filterMessageError(errorsData));
          }
          setOpenProgress(true);
        }
      }
    } catch (err) {
      const errorMessage =
        err.response?.data?.message ||
        'Ocorreu um erro ao inserir novos dados.';
      dispatch(setSnackbar(true, 'error', errorMessage));
      throw new Error(errorMessage);
    }
  };

  const handleCloseSnackbar = () => {
    setErrorsWhenPosting([]);
  };

  // eslint-disable-next-line react/no-unstable-nested-components
  function CustomTitle() {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <div
          style={{
            fontWeight: 500,
            fontSize: '20px',
            fontFamily: 'Roboto',
            marginInlineEnd: '10px',
          }}
        >
          Consumo
        </div>
        {pond ? (
          <div
            style={{
              padding: '5px',
              marginLeft: 'auto',
              border: '1px solid black',
              borderRadius: '10px',
              fontWeight: 600,
            }}
          >
            {pond.description}
          </div>
        ) : null}
      </div>
    );
  }

  return {
    inputs,
    exportData,
    openProgress,
    columns,
    columnsForExport,
    errors,
    CustomTitle,
    errorsWhenPosting,
    handleCloseSnackbar,
    handleImportDataPost,
    pond,
    searchText,
  };
}
